import styled, { keyframes, css } from 'styled-components'

// ── paleta (alinhada à central de relatórios) ──────────────────────
const TEAL = 'var(--teal)'
const TEAL_TEXT = 'var(--teal-text, var(--teal))';
const TEAL_LIGHT = 'var(--teal-light)'
const TEAL_SOFT = 'var(--teal-soft)'
const GRAY_BG = 'var(--bg)'
const GRAY_LINE = 'var(--line)'
const GRAY_TEXT = 'var(--text-muted)'
const GREEN = 'var(--green)'
const RED = 'var(--red, #dc2626)'

const bp = {
    desktop: '1024px',
    tablet: '768px',
    mobile: '540px',
    small: '380px'
}

const expand = keyframes`
    from { opacity: 0; transform: translateY(-6px); }
    to   { opacity: 1; transform: translateY(0); }
`

const shimmer = keyframes`
    0%   { background-position: -400px 0; }
    100% { background-position: 400px 0; }
`

export const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    background: ${GRAY_BG};
    padding: 16px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;

    @media (max-width: ${bp.tablet}) { padding: 12px; }
    @media (max-width: ${bp.mobile}) { padding: 8px; }
`

export const ContainerDivs = styled.div`
    width: 100%;
    max-width: 880px;
    display: flex;
    flex-direction: column;
    gap: 14px;

    @media (max-width: ${bp.mobile}) { gap: 10px; }
`

/* ── Header ─────────────────────────────────────────────────────── */

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 20px;
    background: ${TEAL};
    color: #fff;
    border-radius: 14px;
    box-shadow: 0 6px 18px rgba(0, 62, 79, 0.18);
    flex-wrap: wrap;

    @media (max-width: ${bp.mobile}) { padding: 14px 16px; border-radius: 12px; }
`

export const HeaderInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
    min-width: 0;
`

export const Title = styled.h1`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.2px;

    @media (max-width: ${bp.mobile}) { font-size: 17px; }
    @media (max-width: ${bp.small}) { font-size: 16px; }
`

export const Subtitle = styled.span`
    font-size: 12px;
    font-weight: 600;
    opacity: 0.85;
    text-transform: uppercase;
    letter-spacing: 0.4px;
`

/* ── Cartão de contexto (aluno + período) ──────────────────────── */

export const StudentCard = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 14px;
    padding: 16px 18px;

    @media (max-width: ${bp.mobile}) { padding: 14px; border-radius: 12px; }
`

export const Avatar = styled.div`
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: ${TEAL_SOFT};
    color: ${TEAL_TEXT};
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 16px;
    text-transform: uppercase;
`

export const StudentInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`

export const StudentName = styled.span`
    font-weight: 700;
    font-size: 15px;
    color: ${TEAL_TEXT};
    overflow-wrap: anywhere;
`

export const PeriodTag = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: ${TEAL_LIGHT};
    text-transform: uppercase;
    letter-spacing: 0.3px;
`

/* mantém compatibilidade com import antigo <Span> */
export const Span = StudentInfo

/* ── Editor ─────────────────────────────────────────────────────── */

export const EditorCard = styled.div`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 14px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    animation: ${expand} .2s ease;

    @media (max-width: ${bp.mobile}) { padding: 12px; border-radius: 12px; }
`

export const EditorLabel = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    font-size: 12px;
    font-weight: 600;
    color: ${GRAY_TEXT};
    text-transform: uppercase;
    letter-spacing: 0.3px;
`

export const CharCount = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: ${({ $empty }) => ($empty ? RED : GRAY_TEXT)};
    text-transform: none;
    letter-spacing: 0;
`

/* mantém o nome usado no componente; estiliza o ReactQuill por dentro */
export const StyledQuillContainer = styled.div`
    width: 100%;

    .ql-toolbar {
        border-radius: 10px 10px 0 0;
        border-color: ${GRAY_LINE};
        background: var(--surface);
        position: sticky;
        top: 0;
        z-index: 2;
    }
    .ql-container {
        border-radius: 0 0 10px 10px;
        border-color: ${GRAY_LINE};
        font-size: 16px;
    }
    .ql-editor {
        min-height: 320px;
        line-height: 1.7;
        color: ${TEAL_TEXT};
    }
    .ql-editor.ql-blank::before {
        color: #9aa5aa;
        font-style: normal;
    }
    .ql-editor:focus { outline: none; }

    @media (max-width: ${bp.mobile}) {
        .ql-editor { min-height: 240px; font-size: 16px; }
    }
`

/* ── Sugestões rápidas (chips) ──────────────────────────────────── */

export const Chips = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`

export const Chip = styled.button`
    background: ${TEAL_SOFT};
    color: ${TEAL_TEXT};
    border: 1px solid var(--teal-soft);
    border-radius: 999px;
    padding: 7px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background .12s ease, transform .12s ease;

    &:hover { background: var(--teal-soft); transform: translateY(-1px); }
    &:active { transform: translateY(0); }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }
`

export const ChipsHint = styled.span`
    font-size: 12px;
    color: ${GRAY_TEXT};
    width: 100%;
`

/* ── Ações ──────────────────────────────────────────────────────── */

export const ActionBar = styled.div`
    display: flex;
    gap: 10px;
    justify-content: flex-end;

    @media (max-width: ${bp.small}) {
        flex-direction: column-reverse;
        & > button { width: 100%; }
    }
`

export const Button = styled.button`
    background: ${TEAL};
    color: #fff;
    border: none;
    padding: 12px 26px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 700;
    min-height: 46px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: filter .12s ease, transform .12s ease;

    &:hover { filter: brightness(1.1); transform: translateY(-1px); }
    &:active { transform: translateY(0); }
    &:disabled { opacity: .6; pointer-events: none; }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }
`

export const GhostButton = styled.button`
    background: var(--surface-2);
    color: ${GRAY_TEXT};
    border: 1px solid ${GRAY_LINE};
    padding: 12px 26px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    min-height: 46px;
    transition: background .12s ease;

    &:hover { background: var(--surface-2); }
    &:disabled { opacity: .6; pointer-events: none; }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }
`

/* mantém o Input antigo como wrapper neutro (compat) */
export const Input = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
`

export const ErrorMessage = styled.div`
    background: var(--red-soft);
    color: ${RED};
    border: 1px solid var(--red);
    padding: 10px 12px;
    border-radius: 8px;
    font-size: 13px;
    text-align: center;
`

export const SuccessMessage = styled.div`
    background: var(--green-soft);
    color: ${GREEN};
    border: 1px solid #cdeac8;
    padding: 10px 12px;
    border-radius: 8px;
    font-size: 13px;
    text-align: center;
`

/* ── Skeleton ───────────────────────────────────────────────────── */

const skeletonBase = css`
    background: linear-gradient(90deg, var(--skel-a) 0%, var(--skel-b) 50%, var(--skel-a) 100%);
    background-size: 800px 100%;
    animation: ${shimmer} 1.3s linear infinite;
    border-radius: 8px;
`

export const SkeletonLine = styled.div`
    ${skeletonBase}
    height: ${({ $h }) => $h || '14px'};
    width: ${({ $w }) => $w || '100%'};
    margin: 4px 0;
`

export const SkeletonCard = styled.div`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

/* ── Voltar ─────────────────────────────────────────────────────── */

export const ToGoBack = styled.div`
    display: flex;
    gap: 6px;
    justify-content: center;
    align-items: center;
    padding: 14px 8px;
    cursor: pointer;
    user-select: none;
    color: ${GRAY_TEXT};
    font-size: 14px;
    min-height: 44px;
    &:hover { color: ${TEAL_TEXT}; }
`

export const SignMessageButtonText = styled.span``
export const SignMessageButtonTextBold = styled.span`
    font-weight: 700;
    color: ${TEAL_TEXT};
`